import type { ChannelMemberResponse } from "stream-chat";

type Params = {
  channelName: string | undefined;
  otherMembers: Array<ChannelMemberResponse>;
  anonymousName: string;
  unnamedChannelName: string;
  isGroup?: boolean;
};

export const getChannelDisplayName = ({
  channelName,
  otherMembers,
  anonymousName,
  unnamedChannelName,
  isGroup: isGroupOverride,
}: Params): string => {
  if (channelName) {
    return channelName;
  }

  const isGroup = isGroupOverride ?? otherMembers.length > 1;

  if (isGroup) {
    const names = otherMembers
      .map(({ user }) => user?.name || anonymousName)
      .join(", ");
    return names || unnamedChannelName;
  }

  return otherMembers[0]?.user?.name || anonymousName;
};
